'use strict'
/*
  Base puzzle class.
*/

export class Puzzle {
  constructor (data = new Uint8Array()) {
    this._data = data
  }

  // Import a file.
  //
  // Dummy method.
  importPuzzle (file) {
    this._data = file

    this._parsePuzzle()

    return this
  }

  set title (value) {
    return this['_title'] = value
  }

  get title () {
    return this['_title']
  }

  set author (value) {
    return this['_author'] = value
  }

  get author () {
    return this['_author']
  }

  set copyright (value) {
    return this['_copyright'] = value
  }

  get copyright () {
    return this['_copyright']
  }

  set notepad (value) {
    return this['_notepad'] = value
  }

  get notepad () {
    return this['_notepad']
  }

  set instructions (value) {
    return this['_instructions'] = value
  }

  get instructions () {
    return this['_instructions']
  }

  /* Protected methods */
}

export function mandatory () {
  throw new Error('Missing parameter')
}

export class ParseError extends Error {}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/puzzle.js
// module id = 238
// module chunks = 0